import graphQLApi from '../../utils/api/graphql';

const state = {
  batteryIOData: null,
  batteryChartData: null,
  latestAppData: null,
  lastMinuteAppData: null
};

const mutations = {
  SET_BATTERY_IO_DATA(stateParam, data) {
    const innerState = stateParam;
    innerState.batteryIOData = data;
  },
  SET_BATTERY_CHART_DATA(stateParam, data) {
    const innerState = stateParam;
    innerState.batteryChartData = data;
  },
  SET_DEVICE_DATA(stateParam, data) {
    const innerState = stateParam;
    innerState.latestAppData = data;
  },
  SET_LASTMINUTE_DATA(stateParam, data) {
    const innerState = stateParam;
    innerState.lastMinuteAppData = data;
  }
};

const actions = {
  getBatteryIOData({ commit }, queryObject) {
    return new Promise((resolve, reject) => {
      graphQLApi
        .getBatteryIOData(queryObject)
        .then(batteryIOData => {
          commit('SET_BATTERY_IO_DATA', batteryIOData);
          resolve(batteryIOData);
        })
        .catch(err => {
          console.warn('GraphQL::getBatteryIOData()', err);
          commit('SET_BATTERY_IO_DATA', null);
          reject(err);
        });
    });
  },

  getBatteryChartData({ commit }, queryObject) {
    return new Promise((resolve, reject) => {
      return graphQLApi
        .getBatteryIOData(queryObject)
        .then(batteryChartData => {
          commit('SET_BATTERY_CHART_DATA', batteryChartData);
          resolve(batteryChartData);
        })
        .catch(err => {
          console.warn('GraphQL::getBatteryChartData()', err);
          commit('SET_BATTERY_CHART_DATA', null);
          reject(err);
        });
    });
  },

  getLatestAppData({ commit }, queryObject) {
    return new Promise((resolve, reject) => {
      graphQLApi
        .getLatestAppData(queryObject)
        .then(latestAppData => {
          commit('SET_DEVICE_DATA', latestAppData);
          resolve(latestAppData);
        })
        .catch(err => {
          console.warn('GraphQL::getLatestAppData()', err);
          commit('SET_DEVICE_DATA', null);
          reject(err);
        });
    });
  },

  getLastMinuteData({ commit }, queryObject) {
    return graphQLApi
      .getLastMinuteData(queryObject)
      .then(lastMinuteData => {
        commit('SET_LASTMINUTE_DATA', lastMinuteData);
      })
      .catch(err => {
        console.warn('GraphQL::getLastMinuteData()', err);
        commit('SET_LASTMINUTE_DATA', null);
        return null;
      });
  }
};

const getters = {
  batteryIOData: () => state.batteryIOData,
  batteryChartData: () => state.batteryChartData,
  latestAppData: () => state.latestAppData,
  lastMinuteAppData: () => state.lastMinuteAppData,
  latestGridMeterApp: () => (state.latestAppData || {}).GRID_METER_APP || {},
  latestLgBatteryApp: () => (state.latestAppData || {}).LG_BATTERY_APP || {},
  latestPvMeterApp: () => (state.latestAppData || {}).PV_METER_APP || {},
  latestPowerInverterReadApp: () => (state.latestAppData || {}).POWER_INVERTER_READ_APP || {},
  latestPowerInverterWriteApp: () => (state.latestAppData || {}).POWER_INVERTER_WRITE_APP || {},
  latestPower3ParameterPublisherApp: () =>
    (state.latestAppData || {}).POWER3_PARAMETER_PUBLISHER_APP || {},
  latestPower3ParameterManagerApp: () =>
    (state.latestAppData || {}).POWER3_PARAMETER_MANAGER_APP || {},
  latestPower3DeviceHeartbeatApp: () =>
    (state.latestAppData || {}).POWER3_DEVICE_HEARTBEAT_APP || {}
};

export default {
  state,
  mutations,
  actions,
  getters
};
